import {decompose} from './decompose'
import {rotatePoint} from './rotatePoint'

export const getShapeEdges = (shape, stage) => {
  const transform = stage.getAbsoluteTransform().copy()
  transform.invert()
  let newAttrs, type
  type = shape.getClassName()
  if (type === 'Rect') {
    const matrix = transform
      .multiply(shape.getAbsoluteTransform())
      .getMatrix()
    newAttrs = {
      ...shape.getAttrs(),
      ...decompose(matrix)
    }
  } else {
    newAttrs = shape.getClientRect({relativeTo: stage})
  }

  const {
    x,
    y,
    width,
    height,
    scaleX = 1,
    scaleY = 1,
    rotation = 0
  } = newAttrs
  const uwidth = width * scaleX
  const uheight = height * scaleY
  const angle = Konva.getAngle(rotation)

  if (type === 'Circle') {
    const TOPCENTER = rotatePoint(
      {x, y},
      {x: x + uwidth / 2, y},
      angle
    )
    const RIGHTCENTER = rotatePoint(
      {x, y},
      {x: x + uwidth, y: y + uheight / 2},
      angle
    )
    const BOTTOMCENTER = rotatePoint(
      {x, y},
      {x: x + uwidth / 2, y: y + uheight},
      angle
    )
    const LEFTCENTER = rotatePoint(
      {x, y},
      {x: x, y: y + uheight / 2},
      angle
    )
    return {
      topCenter: TOPCENTER,
      rightCenter: RIGHTCENTER,
      bottomCenter: BOTTOMCENTER,
      leftCenter: LEFTCENTER
    }
  } else {
    const TOPLEFT = {x, y}
    const BOTTOMLEFT = rotatePoint(
      {x, y},
      {x: x, y: y + uheight},
      angle
    )
    const TOPRIGHT = rotatePoint({x, y}, {x: x + uwidth, y}, angle)
    const BOTTOMRIGHT = rotatePoint(
      {x, y},
      {x: x + uwidth, y: y + uheight},
      angle
    )
    const TOPCENTER = rotatePoint(
      {x, y},
      {x: x + uwidth / 2, y},
      angle
    )
    const RIGHTCENTER = rotatePoint(
      {x, y},
      {x: x + uwidth, y: y + uheight / 2},
      angle
    )
    const BOTTOMCENTER = rotatePoint(
      {x, y},
      {x: x + uwidth / 2, y: y + uheight},
      angle
    )
    const LEFTCENTER = rotatePoint(
      {x, y},
      {x: x, y: y + uheight / 2},
      angle
    )
    return {
      topLeft: TOPLEFT,
      bottomLeft: BOTTOMLEFT,
      topRight: TOPRIGHT,
      bottomRight: BOTTOMRIGHT,
      topCenter: TOPCENTER,
      rightCenter: RIGHTCENTER,
      bottomCenter: BOTTOMCENTER,
      leftCenter: LEFTCENTER
    }
  }
}



// WEBPACK FOOTER //
// ./src/components/schemaFonctionnel/helper/getShapeEdges.js